module.exports = "/_next/static/images/illustration_planet-fb1e4b8127573e83865114b70cb99c78.svg";